import { To, useNavigation } from 'react-router-dom';

import { LoadingButton, Props } from '../LoadingButton';

export const NavigatingButton = ({
  to,
  ...props
}: Omit<Props, 'loading'> & { to: To }) => {
  const navigation = useNavigation();

  return (
    <LoadingButton
      to={to}
      {...props}
      loading={navigation.location?.pathname === to}
    />
  );
};
